<template>
    <div>
        <div class="content" id="news-index"> 
            <div class="banner">
                <div class="banner-search">
                    <div>
                        <div class="search-item">
                            <p>新闻资讯</p>
                            <div></div>    
                        </div>
                    </div>
                </div>
                <el-carousel class="banner-imgs" :interval="8000" indicator-position="none">
                    <el-carousel-item v-for="(bannerImg, index) in bannerList" :key="index">
                        <img :src="bannerImg.url?bannerImg.url:require('@/assets/imgs/banner_news.png')"
                            style="width:100%;height:100%;"/>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="news" style="display:block">
                <div class="location">
                    <p>当前位置 > 新闻资讯 > {{paraName}}</p>
                </div>
                <el-divider></el-divider>
                <div class="units">
                    <div class="unit" v-for="item in data" :key="item.id">
                        <!-- <div>
                            <img :src="require('@/assets/imgs/pic1.jpg')">
                        </div> -->
                        <div class="info">
                            <p class="title">{{item.title}}</p>
                            <p class="date">{{item.createDate}}</p>
                            <p class="summery">{{item.summery}}...</p>
                            <div class="btm">
                                <el-button @click='onClick(item.id)'>查看更多>></el-button>
                            </div>
                            <div style="height:0.33px;margin:23px 0; border: 0.33px dashed #DEDEDE;" ></div>
                        </div>                        
                    </div>
                </div>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page='PageIndex'
                    @current-change="handleCurrentChange"
                    :page-size='8'
                    :total="count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/css/newsInfo.less";
import PortalApi from "@/api/portal/index";
export default {
    data(){
        return{
            PageIndex:1,
            PageSize:8,
            count:0,
            bannerList: [
            {
                url: require("@/assets/imgs/banner_news.png"),
                urlAddr: "#",
            },
            ],
            data: []
        }
    },
    methods:{
        onClick(id){
            this.$router.push({ path: "NewsDetail", query: { menu:"新闻资讯", name:this.paraName, type:0, id: id} })
        },
        handleCurrentChange(val) {
           // 改变默认的页数
           this.PageIndex=val
           this.getData()

           window.scrollTo(0,290);
        },
        getData() {
            PortalApi.getArticleListBySubmoduletype(this.paraType,this.paraId,this.PageIndex-1,this.PageSize)
                .then(
                    (res) => {
                        this.data = res.data;
                        this.count = res.count
                    },
                    (err) => {
                        this.$message({
                        message: err,
                        center: true,
                        });
                    }
                    )
                    .catch((error) => {
                    this.$message({
                        message: error,
                        center: true,
                });
            });            
        },
    },
    created(){
        this.PageIndex = Number(localStorage.getItem('pageIndex')) || 1
        this.getData()
    },
    computed:{
        paraId: function(){
            return this.$route.query.id;
        },
        paraName: function(){            
            return this.$route.query.name;
        },
        paraType: function(){            
            return this.$route.query.type;
        },
    },
    watch: {
        // 直接跳转页面时，页面不会刷新，这里使用监听路由的变化实现数据刷新
        $route(to, from) {
            if (to.name == "News" && to.query.id != from.query.id) {
                this.data = {};
                //重新获取数据
                this.getData();
            }
        },
    },
}
</script>
